// A successful event RSVP, announced from the hook that writes it so the UI can
// react to it once, app-wide, instead of at each of the eight surfaces that
// render an attendance menu.
export interface RsvpAnnouncement {
  eventId: string
  status: 'interested' | 'going'
}

let handler: ((rsvp: RsvpAnnouncement) => void) | null = null

export function announceRsvp(rsvp: RsvpAnnouncement) {
  handler?.(rsvp)
}

export function registerRsvpHandler(h: (rsvp: RsvpAnnouncement) => void) {
  handler = h
  return () => {
    handler = null
  }
}
